import { ActionTree } from 'vuex';
import { setupApollo } from '../../../lib/apollo_setup';
import { PREPOPULATE_RESERVATION_QUERY } from '@/graphql/backup_care/queries';
import { JobState } from './state';
import { CREATE_JOB_POST } from '@/graphql/job_post/mutations';

const apolloProvider = setupApollo();
export const actions: ActionTree<JobState, any> = {
  async createJobPost(_, jobInput) {
    const apolloClient = apolloProvider.defaultClient;
    try {
      const response = await apolloClient.mutate({
        mutation: CREATE_JOB_POST,
        variables: { jobInput },
      });

      return response.data;
    } catch (error) {
      console.error('Error creating job post:', error);
      throw error;
    }
  },

  async fetchReservationFromQueryParam({ commit, state }) {
    try {
      const { data } = await apolloProvider.defaultClient.query({
        query: PREPOPULATE_RESERVATION_QUERY,
      });

      const reservation = data?.corp?.backupCare?.bhReservationRequests.find(
        (res) => res.bhReservationRequestId === state.reservationId
      );

      commit('setReservation', reservation);
    } catch (error) {
      console.error('Error fetching reservations', error);
      commit('setReservation', null);
    }
  },
};

export default actions;
